<template>
  <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in">
        <v-container fluid class="pa-3">

          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-toolbar-title>Doc Template</v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-toolbar-items>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn small fab @click="addNewRecord_onClick()" v-on="on">
                          <v-icon>add_circle_outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Add Template</span>
                    </v-tooltip>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text class="pa-0">
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-flex xs12>

                        <v-expansion-panel>
                          <v-expansion-panel-content style="background-color: #bacccc;">
                            <template v-slot:header>
                              <div style="font-size: medium;">Filter Panel</div>         
                            </template>

                            <v-container class="pt-0">
                              <v-layout row wrap>
                                <v-flex class="text-xs-right">
                                  <v-btn color="orange" small fab @click="selected_filter.push({field:'',value:''})"><v-icon color="white">add</v-icon></v-btn>
                                  <v-btn color="green" @click="refreshData()">GENERATE NOW</v-btn>
                                  <v-btn color="cyan lighten-1" @click="selected_filter=[], refreshData()">RESET FILTER</v-btn>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex>
                                  <v-card>
                                    <v-card-text v-if="selected_filter.length > 0">
                                      <v-container>
                                        <v-layout row wrap
                                          v-for="(item,i) in selected_filter"
                                          :key="i"
                                        >
                                          <v-flex xs12 md5>
                                            <v-select
                                              v-model="selected_filter[i].field"
                                              :items="get_filterable_columns"
                                              clearable
                                              item-text="text"
                                              item-value="value"
                                              label="select field"
                                            ></v-select>
                                          </v-flex>
                                          <v-flex xs12 md1 class="text-md-center">
                                            contains
                                          </v-flex>
                                          <v-flex xs12 md5>
                                            <v-text-field
                                              v-model="selected_filter[i].value"
                                              label="your text"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex xs12 md1>
                                            <v-layout justify-space-around class="mb-2">
                                              <span class="group pa-2">
                                                <v-btn color="red" small fab @click="selected_filter.splice(i,1)" :disabled="false"><v-icon color="white">clear</v-icon></v-btn>
                                                
                                              </span>
                                            </v-layout>
                                          </v-flex>

                                        </v-layout>
                                      </v-container>
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                              </v-layout>

                            </v-container>
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-data-table
                          id="appraisal_table_id"
                          ref="appraisal_table_ref"
                          :headers="table_setting.headers"
                          :items="table_setting.records"
                          :loading="table_setting.loading"
                          must-sort
                          :pagination.sync="table_setting.pagination"
                          :rows-per-page-items="table_setting.rows_per_page_items"
                          :total-items="table_setting.pagination.totalItems"
                          class="elevation-1"
                        >
                          <v-progress-linear color="blue" indeterminate>
                            <template v-slot:progress>
                            </template>
                          </v-progress-linear>
                          <template v-slot:items="props">
                            <td class="pa-1 pl-3">{{ props.item.id }}</td>
                            <td class="pa-1">{{ props.item.name }}</td>
                            <td class="pa-1">
                              {{
                              convert_2_locale_datetime(props.item.reated_date)
                              }}
                            </td>
                            <td class="pa-1">{{ props.item.status }}</td>

                            <td class="justify-center layout px-0">
									            <v-menu bottom left offset-y>
									            	<template v-slot:activator="{ on }">
									            		<v-btn small icon v-on="on">
									            			<v-icon color="primary">more_vert</v-icon>
									            		</v-btn>
									            	</template>

									            	<v-list dense class="pa-0">
									            		<v-list-tile
                                    v-for="(item, i) in more_items"
                                    :key="i"
                                    @click="more_onClick()"
                                  >
									            			<v-list-tile-action>
									            				<v-icon small left>{{more_items[i].icon}}</v-icon>
									            			</v-list-tile-action>
									            			<v-list-tile-title>{{more_items[i].text}}</v-list-tile-title>
									            		</v-list-tile>
									            	</v-list>
									            </v-menu>
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

        </v-container>
      </v-slide-y-transition>

    </v-flex>
  </v-layout>

</template>

<script>
// import axios from "axios";
import auth from "../../functions/auth";
import common from "../../functions/general";
import comm from "../../functions/communication.api";
// import qb from "../../functions/query.builder";

export default {
  name: "doc_template", // copy code from appraisal_listing
  // components: {
  //   PageLayout: PageLayout,
  // },
  data() {
    return {
      username: "",
      new_filter: {
        condition: "and",
        rules: []
      },
      showMenu: false,
      filters_setting: {
        filter_row: 0,
      },
      my_filter: {
        field: "",
        value: "",
      },
      selected_filter: [
        // {
        //   field:"hub",
        //   value:"MYPG",
        // },
        // {
        //   field:"department",
        //   value:"CSDS",
        // },
      ],
      table_setting: {
        loading: false,
        rows_per_page_items: [2, 10, 40, 70, 100],
        headers: [
          {
            text: "#ID",
            class: "pa-1 pl-3",
            value: "id", // to update
            filterable: true,
            sortable: true,
            data_type: Number
          },
          {
            text: "Name",
            class: "pa-1",
            value: "name", // to update
            filterable: true,
            sortable: true,
            data_type: String
          },
          {
            text: "Created DateTime",
            // align: "left",
            class: "pa-1",
            value: "created_date", // to update
            filterable: true,            
            sortable: true,
            data_type: Number
          },
          {
            text: "Status",
            // align: "left",
            class: "pa-1",
            value: "status", // to update
            filterable: true,
            data_type: String
          }
        ],
        records: [
          {
            "id": 1,
            "name": "adj letter",
            "created_date": "2023-09-27 08:33:47.281603",
            "status": 4
          },{
            "id": 2,
            "name": "bonus letter",
            "created_date": "2023-09-27 08:40:21.237446",
            "status": 4
          },{
            "id": 2,
            "name": "anti-bribe letter",
            "created_date": "2023-10-01 05:43:27.115566",
            "status": 5
          }
        ],      
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 10,
          sortBy: "created",
          totalItems: 0
        },
      },
    //   dialog: {
    //     visible: false,
    //     title: "",
    //     appraisee: "",
    //     appraiser: "",
    //     iframe_url: "",
    //     height:"",
    //     rec_id:""
    //   },
      status_option: [],
      selected: { // to update
        id: "",
        name: "",
        created_date: "",
        status: ""
      },
      more_items: [
        {
          "icon": "visibility",
          "text": "View"
        },{
          "icon": "edit",
          "text": "Edit"
        },{
          "icon": "check",
          "text": "Set Active"
        },{
          "icon": "lock_outline",
          "text": "Set Lock"
        },{
          "icon": "clear",
          "text": "Set Inactive"
        }
      ]
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table_setting.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "table_setting.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    },
    // "selected_filter":{
    //   handler:function(){
    //     console.log(this.selected_filter);
    //   }
    // }
  },
  async mounted() {
    // window.document.title="Talent Mgmt";
    this.username = auth.getUsername();

    var self = this;

    this.status_option = await common.App.getGeneralOptions(
      "General",
      "status",
      ["id", "value"]
    );

    // function handleMessage(e) {
    //   if (e.data.event == "form_data_saved") {
    //     self.dialog.visible = false;
    //     self.dialog.iframe_url ="";
    //     self.dialog.height = e.data.window.height;
    //   }
    //   if (e.data.event == "form_loaded") {
    //     self.dialog.height = e.data.window.height + 350;
    //   }

    // }
    
    // window.addEventListener("message", handleMessage, false);
  },
  created (){
    auth.hideHeader(false);
  },
  methods: {
    convert_2_locale_datetime(date) {
      return common.App.to_locale_datetime(date);
    },

    async refreshData() {
     
      // var sorting = [
      //   // {sortBy: "year", descending: true},
      //   // {sortBy: "qtr", descending: true},
      // ];

      // sorting.push({
      //   sortBy: this.table_setting.pagination.sortBy,
      //   descending: this.table_setting.pagination.descending 
      // });

      // var sort_el = "";
              
      // for (var m in sorting) {
      //   sort_el += " , j." + sorting[m].sortBy + (sorting[m].descending?' desc':' asc');
      // }
      // var substr_pos1 = 2;
      // var sort_el_length = sort_el.length;
      // sort_el = sort_el.substr(substr_pos1, sort_el_length - substr_pos1); // to remove , of first sorting element
      // var str1 = " sort";
      // sort_el = str1.concat(sort_el);


      // var filter_el = "";
      // if (this.selected_filter.length > 0) {
      //   var temp_filter = this.selected_filter;
        
      //   for (var i in temp_filter) {
      //     filter_el += ' && like(j.' + temp_filter[i].field + ', "%' + temp_filter[i].value + '%", true)';
      //   }

      //   var substr_pos = 3;
      //   var filter_el_length = filter_el.length;
      //   filter_el = filter_el.substr(substr_pos, filter_el_length - substr_pos); // to remove && of first filter element
      //   var str2 = " filter";
      //   filter_el = str2.concat(filter_el);
      // }

      // var q_return = [
      //   '{"year":rec.submission.data.year.name' ,
      //   ' "qtr":rec.submission.data.quater.name' ,
      //   ' "appraisee":rec.submission.data.appraisee' ,
      //   ' "appraiser":rec.submission.data.appraiser' ,
      //   ' "hub":rec.submission.data.hub' ,
      //   ' "department":rec.submission.data.department' ,
      //   ' "form":form.name' ,
      //   ' "created":rec.created_datetime' ,
      //   ' "type":rec.submission.data.type.name' ,
      //   ' "data_id":rec._id' ,
      //   ' "form_id":rec.form_id' ,
      //   ' "revision":form.revision' ,
      //   ' "ave_score":rec.submission.data.ave_score}'];

      // q_return = q_return.join();


      // var q_record_base = [
      //   'let records_base = (for form in forms filter contains(form.name,"Form 47") ', 
      //   'for rec in form_datas filter contains(rec.form_id,form._id) return ',
      //   q_return,
      //   ')'
      // ];

      // q_record_base = q_record_base.join("");


      // var temp_pagination = (this.table_setting.pagination.page-1) * this.table_setting.pagination.rowsPerPage;
      // var q_record = [
      //   q_record_base,
      //   ' let records_all = (for j in records_base',
      //   filter_el,
      //   sort_el,
      //   ' return j) let records = (for m in records_all limit ',
      //   temp_pagination,
      //   ',',
      //   this.table_setting.pagination.rowsPerPage,
      //   ' return m) let Tcount = count(for k in records_all return 1) return {"totalItems":Tcount, "records":records}'
      // ];

      // q_record = q_record.join("");
      
      
      // var results = await comm.getFormData(q_record)
      // this.table_setting.records = results.data[0].records;
      // this.table_setting.pagination.totalItems = results.data[0].totalItems;
    },    
    more_onClick(item) {
      // this.dialog.visible = true;
      // this.dialog.title = "View";
      // this.dialog.appraisee = item.appraisee;
      // this.dialog.appraiser = item.appraiser;
      // this.dialog.rec_id = item.data_id;
      // this.dialog.iframe_url =
      //   comm.form_ip +
      //   // "http://192.168.22.227:5651/form?form_id=" +
      //   item.form_id +
      //   "&form_data_id=" +
      //   item.data_id +
      //   "&readOnly=true";
    },
    addNewRecord_onClick() {
      // this.$router.push({ path: "/doc_create" });
      // window.location.href = data.path + "?pageid=" + data.id ;
      window.location.href = "/doc_create?pageid=223";
    },
    viewMenu() {
      this.showMenu = true;
    },
    // main_menu_onClick(action_name) {
    //   this.$router.push({ name: action_name });
    // },
    save_onClick() {
      // let self = this;

      // this.$validator.validateAll().then(async result => {
      //   if (result) {
      //     let result = await common.wBackEndComm.PostData(
      //       "company/crud_company/",
      //       self.selected
      //     );

      //     if (result.data.Status == 1) {
      //       self.dialog.visible = false;
      //       self.refreshData();
      //       common.wMsgBox.Success(result.data.Description);
      //     } else {
      //       common.wMsgBox.Error(result.data.Description);
      //     }
      //   }
      // });
    }
  }
};
</script>

<style>

</style>
